
import { combineReducers } from '@reduxjs/toolkit'

import courseSessionReducer from './course-session'
import studentReducer from './student/teacher-student'
import parentStudentReducer from './parent/parent-student'
import finalGradeReducer from './grade-finalGrade'
import parentalAcademicYearReducer from './parental-academic-year'
import parentalStudentCourseSessionReducer from './parental-course-session'
import parentalStudentAttendanceDailyReducer from './parental-attendance-daily'
import parentalGradingScalesReducer from './parental-grading-scales'
import gradingScalesReducer from './grading-scales'

const combinedReducer = combineReducers({
  courseSession: courseSessionReducer,
  student: studentReducer,
  grade_finalGrade: finalGradeReducer,
  parentalStudentCourseSession: parentalStudentCourseSessionReducer,
  parentalAcademicYear: parentalAcademicYearReducer,
  parentalStudentAttendanceDaily: parentalStudentAttendanceDailyReducer,
  parentalGradingScales: parentalGradingScalesReducer,
  gradingScales: gradingScalesReducer,
  parentStudent: parentStudentReducer,
})

export default combinedReducer
